<template>
<div class="chapter">
<div class="inner_page">
<a id="page_21">
<h2 class="parttit"><span class="line0"><span class="bold">TIBET</span></span></h2>
<h2 class="parttit1"><span class="bold">1959</span></h2>
</a><a id="page_22">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Part02.vue?3673746c